module.exports = require('./dist/echarts-amap.min.js')



//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts-amap/index.js
// module id = I8dn
// module chunks = 188